import { CheckCircle2, Clock3, RotateCcw, XCircle } from "lucide-react";

const formatTime = value => {
  if (!value) return "";
  return new Date(value).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const cleanReason = value => (value || "").replace(/^Cancelled from KDS:\s*/i, "").replace(/^Updated from Live KOT:\s*/i, "");

const KdsActivityCard = ({ item, type, busy, onRecall }) => {
  const cancelled = type === "cancelled";
  const isBusy = busy === item.state.kitchenTicketItemStateId;

  return (
    <article className={`kds-activity-card ${cancelled ? "is-cancelled" : "is-completed"}`}>
      <header>
        <span className="kds-activity-status">
          {cancelled ? <XCircle size={17} /> : <CheckCircle2 size={17} />}
          {cancelled ? "Cancelled" : "Completed"}
        </span>
        <span className="kds-activity-time"><Clock3 size={14} /> {formatTime(item.completedAtUtc)}</span>
      </header>
      <div className="kds-activity-reference">
        <span>{item.sourceType === "TAKEAWAY" ? "Takeaway" : "Dine-in"}</span>
        <strong>{item.location} {"\u00B7"} #{item.orderReference}</strong>
      </div>
      <h3><span>{item.quantity}{"\u00D7"}</span>{item.itemName}</h3>
      {item.addonSummary && <p className="kds-addons"><strong>Add-ons:</strong> {item.addonSummary}</p>}
      {item.note && <p className="kds-note"><strong>Item note</strong><span>{item.note}</span></p>}
      {cancelled && <p className="kds-cancel-reason"><strong>Reason</strong><span>{cleanReason(item.reason) || "No reason recorded"}</span></p>}
      {!cancelled && item.canRecall && (
        <button type="button" disabled={isBusy} onClick={() => onRecall(item)}>
          <RotateCcw size={17} /> {isBusy ? "Recalling..." : "Recall / Re-fire"}
        </button>
      )}
      {!cancelled && !item.canRecall && <small className="kds-activity-locked">This ticket is already served, collected or billed.</small>}
    </article>
  );
};

export default KdsActivityCard;
